import UTMParams from "@verivest/shared-components/src/utils/utm";
export default UTMParams;
